const api_address = 'https://spotify-api-wrapper.appspot.com';

export const artistData = `${api_address}/artist/`;

export const popularSongData = `${api_address}/artist/`;
